export default {
  paymentSuccess: {
    event: "ls_paymentSuccess",
  },
  paymentFailure: {
    event: "ls_paymentFailure",
  },
  introductionView: {
    event: "ls_introduction",
  },
  chooseView: {
    event: "ls_choose",
  },
  chooseOptionsView: {
    event: "ls_chooseOptions",
  },
  uploadResumeView: {
    event: "ls_uploadResume",
  },
  selectedDocumentView: {
    event: "ls_selectedDocument",
  },
  personalInfoView: {
    event: "ls_personalInfo",
  },
  experienceTipsView: {
    event: "ls_experienceTips",
  },
  experienceEditView: {
    event: "ls_experienceEdit",
  },
  educationTipsView: {
    event: "ls_educationTips",
  },
  educationEditView: {
    event: "ls_educationEdit",
  },
  skillsTipsView: {
    event: "ls_skillTips",
  },
  skillsEditView: {
    event: "ls_skillEdit",
  },
  summaryTipsView: {
    event: "ls_summaryTips",
  },
  summaryEditView: {
    event: "ls_summaryEdit",
  },
  signUpView: {
    event: "ls_signUp",
  },
  signInView: {
    event: "ls_signIn",
  },
  resumeRevisitView: {
    event: "ls_resumeRevisit",
  },
  planView: {
    event: "ls_plan",
  },
  checkoutView: {
    event: "ls_checkout",
  },
  confirmationView: {
    event: "ls_confirmation",
  },
};
